import React from 'react';
import {
  Heading,
  Container,
  ContainerProps,
  HeadingProps,
} from '@hover/blueprint';

interface Props extends ContainerProps {
  heading?: string;
  body: string;
  headingProps?: HeadingProps | null;
  bodyProps?: HeadingProps | null;
}

const HeaderDescription: React.FC<Props> = ({
  body,
  heading,
  headingProps,
  bodyProps,
  ...props
}) => (
  <Container
    centerContent
    px={{ base: 500, tablet: '56px' }}
    maxWidth="1100px"
    {...props}
  >
    {heading && (
      <Heading
        size={{ base: 500, tablet: 600, desktop: 700 }}
        textAlign="center"
        isLight
        style={{ marginBottom: 24 }}
        as="h2"
        {...headingProps}
      >
        {heading}
      </Heading>
    )}
    <Heading
      as="p"
      size={{ base: 300, tablet: 500 }}
      textAlign="center"
      isDisplay
      style={{ marginBottom: 0 }}
      {...bodyProps}
    >
      {body}
    </Heading>
  </Container>
);

export default HeaderDescription;
